<template>
    <div>
        <div class="main-news">
            <h3 class="main-sub-tit">은평人미디어</h3>
            <a :href="$cp + 'opinion'" class="btn-more">더보기</a>

            <div class="main_news scroll">
                <ul>
                    <li v-for="tv in internetTvList" :key="tv.amnDataSqno" @click="play(checkUrl(tv.val8))">
                        <a href="javascript: void(0)">
                            <p class="photo"><img :src="tv.val5" style="width: 100%;" :alt="tv.val2" /></p>
                            <p class="title" v-text="tv.val2"></p>
                            <p class="date" v-text="getTimeText(tv.basdtVal)"></p>
                        </a>
                    </li>
                </ul>
            </div>

        </div>
        <transition name="modal">
            <InternetTvWin v-show="isShowVideo" @close-main-video-win="showVideoWin(false)" />
        </transition>
    </div>
</template>

<script>
import InternetTvWin from '@/views/main/InternetTvWin.vue'
import commonConstMixin from "@/store/common.const.mixin.js";

export default {
    name: 'InternetTv',
    data() {
        return {
            params: {
                orderColnms: ['basdt_val'],
                sortDirs: ['DESC'],
                page: 1,
                pageSize: 8
            },
            isShowVideo: false,
        }
    },
    computed: {
        internetTvList() {
            return this.$store.getters.getInternetTvList;
        }
    },
    created() {},
    methods: {
        getTimeText(datetime) {
            var tmpDate = datetime.substring(0, 4) + "/" + datetime.substring(4, 6) + "/" + datetime.substring(6, 8) + " " + datetime.substring(8, 10) + ":" + datetime.substring(10, 12) + ":" + datetime.substring(12, 14);
            var timestamp = new Date().getTime();
            var date = new Date(tmpDate);

            var min = 1000 * 60;
            var hour = min * 60;
            var day = hour * 24;

            var stamp = timestamp - date.getTime();

            var text = "1분전";
            if (stamp > day) {
                text = Math.floor(stamp / day) + "일전";
            } else if (stamp > hour) {
                text = Math.floor(stamp / hour) + "시간전";
            } else if (stamp > min) {
                text = Math.floor(stamp / min) + "분전";
            }
            return text;
        },
        play(url) {
            this.isShowVideo = true;
            this.$eventBus.$emit("play-youtube", url);
        },
        checkUrl(url) {
            if (window.location.protocol == "http:") {
                return url.replace('https:', 'http:');
            }
            return url;
        },
        showVideoWin(isShow) {
            this.isShowVideo = isShow;
        },
    },
    components: {
        InternetTvWin
    },
    mixins: [commonConstMixin],
}
</script>

<style scoped>

</style>